<template>
  <!-- eslint-disable  -->
  <div class="w-100">
    <!-- Navigation and related information START -->
    <div id="nav-info" role="navigation" class="container-fluid fixed-top w-100 px-0 background-white" style="z-index: 10;">
      <section-navigation :pageData="pageData"></section-navigation>
    </div>
    <div role="main" class="section-form" :class="{'quote-panel-open': quotePanelStatus, 'quote-panel-close': !quotePanelStatus}">
    <!-- REQUIRED-->
    <div class="required"></div>

    <div class="container page-wrap">
     <div class="row no-gutters mx-0 my-3">
      <div class="col-9">
      <!-- TOP Instruction SECTION -->
      <div class="d-flex justify-content-center mx-auto mt-3 mb-1" v-if="blurbs.formtop && blurbs.formtop.visible">
        <div class="alert alert-primary my-0 py-2 w-100" role="alert">
          <div class="row no-gutters">
            <div class="d-inline-block pr-2 my-auto">
              <img width="25px" height="25px" src="../../../assets/info-circle-blue.svg" alt="info">
            </div>
            <div class="col d-inline-block my-auto smaller-font-content"  v-html="blurbs.formtop.content">
            </div>
          </div>
        </div>
      </div>
      <!-- TOP Instruction SECTION END -->
     </div>
      <div class="col-3"  v-if="($store.state.buttonState.quoteSummaryData && $store.state.buttonState.quoteSummaryData.quote_status !== 'Bound') && (appointedCarrierStatus)" >
        <div class="smaller-text-secondary text-right" >Last updated {{lastRC1DateTimeString}}</div>
        <button type="button" tabindex="0"  class="btn btn-primary float-right refreshButton mb-2"  role="button" @click="refreshRates()"><i  class="fas">&#xf01e;</i>&nbsp;Refresh Rates</button>
       </div>
     </div>
      <div id="carrier-results" class="row no-gutters mx-0 my-3">
        <div class="col-12">
          <div>
            <div class="row mx-0">
              <div class="col-12 px-0">
              <!-- Carrier Components BEGIN -->

                <!--CARRIER RESULTS TABLE START-->
                <div id="results-table" class="container col-12">
                  
                  <div class="row" v-show="complete && carrierSuccessArray.length > 0">
                    <div class="col-9">
                      <!--Results Header START-->
                      <div id="results-head" class="row smaller-font-content font-weight-bold border-bottom border-bottom-carriers bg-white" v-show="complete && carrierSuccessArray.length > 0">
                          <!--Carrier Column-->
                          <div class="col-3 col-head" :class="{ selected: sortTabActive.name }">
                            Insurance Carrier
                          </div>
                          <!--Monthly Payment Column-->
                          <div class="col-3 col-head selected" :class="{ selected: sortTabActive.monthly_premium }">
                            Avg. Monthly Payment
                          </div>
                          <!--Total Payment Column-->
                          <div class="col-3 col-head" :class="{ selected: sortTabActive.payinfull_amount }">
                            Total Payment
                          </div>
                          <!--Button Column-->
                          <div class="col-3">
                           
                          </div>
                      </div>
                      <!--Results Header END-->
                    </div>
                    <div class="col-3 position-relative export-dropdown-col p-0">
                      <input-select :fieldData="exportDropdown" :ref="exportDropdown.field_name" :exportPDF="exportPDF"></input-select>
                    </div>
                  </div>

                  <!--Progress Bar START-->
                  <div v-show="carrierCount > 0 && showProgressBar === true" class="row progress shadow-sm rounded-0 mb-2">
                    <div class="progress-bar progress-bar-striped progress-bar-animated bg-warning text-dark text-center bold px-3" :ref="'progress_bar'" role="progressbar" aria-valuemin="0" aria-valuemax="100" style="width: 0%;">Retrieving Quotes...</div>
                  </div>
                  <!--Progress Bar END-->
                  <carrier-success v-for="(carrier, cKey) in carrierSuccessArray" :key="cKey+'_carKey'" :carrier='carrier'></carrier-success>
                </div>
                <!-- Knockout Beginning -->
                <div id="knockout-wrap" class="col-12" v-show="carrierErrorArray.length > 0 && complete">
                  <!--KNOCKOUT SECTION HEADER-->
                  <div class="row mt-5">
                    <div class="col-12 py-2 bg-greyed text-white rounded-top" role="heading" aria-level="3">
                      <strong>Carrier Knockouts</strong>
                      <div class="smaller-font-content">The following carrier(s) were unable to return a quote with the provided customer information.</div>
                    </div>
                  </div>
                  <!--KNOCKOUT SECTION HEADER-->
                  <carrier-failure v-for="(carrier, fKey) in carrierErrorArray" :key="fKey+'_failKey'" :carrier='carrier'></carrier-failure>
                </div>
                <div class="col-12 text-center text-secondary my-4" v-if="carrierSuccessArray.length === 0 && carrierErrorArray.length === 0 && complete">
                  <h3>No Carriers Found.</h3>
                  <p>There are no returned carrier matches. This could be caused by a failed system response.</p>
                </div>
                <!-- Carrier Components END -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!appointedCarrierStatus" class="row col-12">
        <div class="text-center col-md-12 appt-error-msg">You’re not appointed by any carriers in this state.</div>
      </div>
    </div>
</div>
<!-- Bound Policy Alert -->
<form-alerts v-if="$store.state.buttonState.quoteSummaryData && $store.state.buttonState.quoteSummaryData.quote_status === 'Bound'" :pageData="policyBindError" :class="{'policy-bound-alert': true, 'margin-25' : quotePanelStatus}"></form-alerts>
</div>
</template>

<script>
/* eslint-disable */

/**
 * Carrier Matches Interview page is the last step in the Interview process. All the information from the preceding pages is used
 * to display quotes from different Insurance Carriers.
 *
 * To see the info sent from the server to render everything EXCEPT carrier info, find 'fetchData.getPageData' and log to console the response.
 * Although this "page" response will not hold any info about Successful/Unsuccessful Carriers, it will hold all the rest of the data for the
 * page such as Help Script, Quote Summary, navigation button states, etc.
 *
 * To see server response that populates our Successful/Unsuccessful carriers area find:
 * fetchData.getCarriersData(url).then((response) => {
 * The "url" is built using the current sessionID and request is sent to the server.
 * Again, the response from the server for this request will hold all the Successful/Unsuccessful carriers.
 *
 * For each successful carrier processed, we will add to the carrierSuccessArray[]. For each unsuccessful carrier processed, we will add to
 * the carrierErrorArray[]. For each successful or unsuccessful array element we v-for through and create a child element of the page: the
 * child element will either be a <carrier-success> or <carrier-failure> child sub-component.
 *
 * The user can always go back to any previous interview page and modify values and then rerun this "Carrier Matches" page to see newly updated
 * results from all of the carriers.
 */
import SectionNavigation from '@/components/presentational/widgets/SectionNavigation';
import FormAlerts from '../../presentational/alerts/FormAlerts';
import InterviewNavigationTitle from '../shared/NavigationTitle';
import fetchData from '../../../services/fetchData';
import common from '../../../services/common';
import axios from '../../../axios-config';
import CarrierSuccess from './CarrierDetailsSuccess';
import CarrierFailure from './CarrierDetailsFailure';
import { stickyDivMixin } from '../../../mixins/stickyDivMixin';
import { pageMixin } from '../../../mixins/pageMixin';
import InputSelect from '../../interactive/InputSelect';

export default {
  mixins: [pageMixin, stickyDivMixin],
  data() {
    return {
      carrierCount: 0,
      showProgressBar: false,
      appointedCarrierStatus: true, 
      carrierProcessed: 0,
      complete: false,
      blurbs: {
        formtop: {
          visible: false,
          content: '',
        },
      },
      lastRC1DateTimeString:'',
      carrierSuccessArray: [],
      carrierErrorArray: [],
      sortTabActive: {
        name: false,
        monthly_premium: false,
        payinfull_amount: false,
      },
      pageData: {
        page_name: '',
        buttons: [],
        fields: [],
        blurbs: [],
        quote_summary: {},
      },      
      exportDropdown : {
        "field_name": "QTE_PRP_ExportPDF",
        "field_type": "select_medium",
        "label": "Share Quote Summary",
        "field_value": "",
        "help_text": "",
        "sub_text": "",
        "placeholder": "Share Quote Summary",
        "visible": true,
        "is_enabled": true,
        "is_required": false,
        "rules": [],
        "values": [
            {
                "display_value": "Print PDF",
                "internal_value": "printpdf",
                "visible": true,
                "display_order": 1
            },
            // {
            //     "display_value": "Email PDF",
            //     "internal_value": "emailpdf",
            //     "visible": true,
            //     "display_order": 2
            // }
        ],
        "has_error": false,
        "error": null
      },
      carriers:[],
    };
  },
  computed: {
  },
  components: {
    SectionNavigation: SectionNavigation,
    carrierSuccess: CarrierSuccess,
    carrierFailure: CarrierFailure,
    interviewNaviTitle: InterviewNavigationTitle,
    FormAlerts,
    InputSelect
  },
  methods: {
    exportPDF() {
      this.exportPDFTo(this.exportDropdown.field_value, this.carriers, 'rc1');
    },
    /**
     * Sort arrays that are populated with JavaScript Number primitive data types. In this case those numbers are floating point values or
     * decimals.
     *
     * The sort buttons can be found at the very top of the Successful Carriers div. We can sort by name, pay-in-full amount or
     * montly payments.
     */
    sortCarrierFloat(key) {
      this.setSortTab(key);

      const sortArg = function sortArg(a, b) {
        return a[key] - b[key];
      };

      this.carrierSuccessArray.sort(sortArg);
    },
    /**
     * Sort arrays that are populated with JavaScript String primitive data types which represents the name of the carrier.
     *
     * The sort buttons can be found at the very top of the Successful Carriers div. We can sort by name, pay-in-full amount or
     * monthly payments.
     */
    sortCarrierName() {
      this.setSortTab('name');

      const sortArg = function sortArg(a, b) {
        const nameA = a.carrier_name.toUpperCase(); // ignore upper and lowercase
        const nameB = b.carrier_name.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      };

      this.carrierSuccessArray.sort(sortArg);
    },
    /**
     * Helper function to sort.
     */
    setSortTab(keyTrue) {
      const keys = Object.keys(this.sortTabActive);
      for (let i = 0; i <= keys.length; i += 1) {
        if (keys[i] === keyTrue) {
          this.sortTabActive[keys[i]] = true;
        } else {
          this.sortTabActive[keys[i]] = false;
        }
      }
    },
    /**
     * Progress bar for when have to make multiple calls for each carrier.
     */
    updateProgressBar() {
      this.carrierProcessed += 1;
      const processedPercentage = Math.ceil((this.carrierProcessed / this.carrierCount) * 100);
      this.$refs.progress_bar.style.width = `${processedPercentage}%`;
      if (processedPercentage === 100 || processedPercentage === '100') {
        this.updateProgressBarStylesComplete();
        this.switchCarrierIcon();
        this.complete = true;
      }
    },
    /**
     * Progress bar for when have to make one call for all carriers.
     */
    updateProgressBarNonIncremental() {
      this.$refs.progress_bar.style.width = '100%';
      this.updateProgressBarStylesComplete();

      this.switchCarrierIcon();
      this.complete = true;
    },
    /**
     * Progress bar helper function.
     */
    updateProgressBarStylesComplete() {
      this.$refs.progress_bar.classList.add('progress-bar-bg');
      this.$refs.progress_bar.style.fontWeight = 'bold';
      this.$refs.progress_bar.style.setProperty('color', '#fff', 'important');
      this.$refs.progress_bar.innerHTML = 'All Carriers Loaded';
      this.$refs.progress_bar.classList.remove('progress-bar-animated', 'progress-bar-striped');
    },
    updateProgressBarOnRefresh(){      
      this.$refs.progress_bar.classList.add('progress-bar-animated', 'progress-bar-striped', 'text-dark');
      this.$refs.progress_bar.style.setProperty('width', '0%');
      this.$refs.progress_bar.innerHTML = 'Retrieving Quotes...';
      this.$refs.progress_bar.style.fontWeight = 'normal';
      this.$refs.progress_bar.style.setProperty('color', '#2f353a', 'important');
      this.$refs.progress_bar.classList.remove('progress-bar-bg');
    },
    /**
     * Switch the Carrier Matches Icon to compelted check-circle but we need a setTimeout() and before that set
     * property to blank string otherwise the stacked styling will be off.
     */
    switchCarrierIcon() {
      let carrierIndex;
      for (let indexTabBtns = 0; indexTabBtns < this.pageData.tab_buttons.length; indexTabBtns += 1) {
        if (this.pageData.tab_buttons[indexTabBtns].name === this.pageData.page_name) {
          carrierIndex = indexTabBtns;
        }
      }

      this.pageData.tab_buttons[carrierIndex].status = '';
      const self = this;

      const timeOut = function timeOUt() {
        self.pageData.tab_buttons[carrierIndex].status = 'ActiveComplete';
      };

      setTimeout(timeOut, 0);
    },
    /**
     * Process Carriers in One Server Response
     */
    processCarriersOneCall(carriers) {
      for (let indexResults = 0; indexResults < carriers.length; indexResults += 1) {
        // if (carriers[indexResults].carrier_id === 3) {
        switch (carriers[indexResults].status) {
          case 'Success':
            this.carrierSuccessArray.push(carriers[indexResults]);
            this.sortCarrierFloat('monthly_premium');
            break;
          case 'Error':
            this.carrierErrorArray.push(carriers[indexResults]);
            break;
          default:
        }
        // }
      }
      this.updateProgressBarNonIncremental();
    },
 
       /**
       * Our Call to retrieve different rates for all carriers
       */
      refreshRates(){
      this.complete=false;
      this.showProgressBar = false;
      this.carrierProcessed=0;
      this.carrierSuccessArray=[];
      this.carrierErrorArray=[];
      const sessionID = this.$store.getters.getSessionID;
      const url = `/carriers/${sessionID}/true`;
      fetchData.getCarriersData(url).then((response2) => {
       this.lastRC1DateTimeString=response2.data.lastRC1DateTimeString;
        // const carriers = response2.data;
        // this.processCarriersOneCall(carriers);
        this.showProgressBar = true;
        this.updateProgressBarOnRefresh();
        this.processCarriersMultipleCalls(response2);

        /*
        this.$nextTick(() => {
          window.scrollTo(0, 0);
        });
        */
      });
      },
    /**
     * Process Multiple Carriers in Multiple Server Responses
     */
    processCarriersMultipleCalls(response) {
      this.carrierCount = response.data.carriers.length;
      const carriers = response.data.carriers;
      const carrierLookupCnt = Object.keys(response.data.carrier_lookup).length;
      if (carrierLookupCnt === 0) {
        this.appointedCarrierStatus = false;
      }
      const startTimeVal = (new Date()).getTime();
      for (let index = 0; index < carriers.length; index += 1) {
        axios.get(carriers[index])
          .then((singleCarrierResponse) => {
            if (singleCarrierResponse) { // Sarang mentioned this could come back as NULL
              for (let indexResults = 0; indexResults < singleCarrierResponse.data.length; indexResults += 1) {
                switch (singleCarrierResponse.data[indexResults].status) {
                  case 'Success':
                    //below code is for PDF generation
                    let temp = {};
                    temp.carrier_id = singleCarrierResponse.data[indexResults].carrier_id;
                    temp.carrierType = "home";
                    this.carriers.push(temp);
                    
                    this.carrierSuccessArray.push(singleCarrierResponse.data[indexResults]);
                    // this.sortCarrierFloat('monthly_premium');
                    break;
                  case 'Error':
                    this.carrierErrorArray.push(singleCarrierResponse.data[indexResults]);
                    break;
                  default:
                  gtag('event', this.$store.getters.getSessionID, {
                  'event_label':JSON.stringify(singleCarrierResponse),
                  'event_category': 'RC1_Exception_Home',
                  'value':JSON.stringify(singleCarrierResponse),
                  });
                }
              }
            }
            this.updateProgressBar();
            if((index+1) === carriers.length) {
              common.gapRecordAnalytics('CarrierMatches');
              // log API response time through application into GA tool
              common.gapRecordAnalyticsGeneric(startTimeVal, 'API', 'CarrierMatches');
            }
          })
          .catch(() => {
            const serverErrorCarrierID = carriers[index].split('/')[2];
            const serverErrorCarrierInfo = response.data.carrier_lookup[serverErrorCarrierID][serverErrorCarrierID];

            if (serverErrorCarrierInfo) {
              const carrierName = serverErrorCarrierInfo.carrier_name;
              const logoPath = serverErrorCarrierInfo.logo_path;
              this.carrierErrorArray.push({ logo_path: logoPath, carrier_name: carrierName, status_message: `${carrierName} General Server Error` });
            } else if (serverErrorCarrierID === 'Ezlynx') {
              var ezObject = response.data.carrier_lookup['Ezlynx'];
              for (var key in ezObject) {
                if (ezObject.hasOwnProperty(key)) {
                  this.carrierErrorArray.push({ logo_path: ezObject[key].logo_path, carrier_name: ezObject[key].carrier_name, status_message: ezObject[key].carrier_name + ' General Server Error' });
                }
              }
            } else {
              this.carrierErrorArray.push({ logo_path: '', carrier_name: 'Carrier', status_message: 'General Server Error' });
            }
            this.updateProgressBar();
          });
      }
    },
  },
  created() {
    const storedPageName=sessionStorage.getItem('navUrl').split("/");
    axios.post(
          `/navs/CarrierMatches`,// API endpoint URL
          {
          fields: '', // All of the current `pageData` fields
          page_name: storedPageName[2], // Current `pageData` `page_name`
          session_id: this.$store.getters.getSessionID, // Current Session ID
        },
    ).then((response) => {
    if(response.data.Navigate.includes('CarrierMatches'))
    {
    /* Call page data API first and then start looking for rates */
    const requestParam = {
      url: this.$store.getters.getNavLink,
    };

    /**
     * Below is where we utilize our 'import fetchData' to get ALL the data except Successful/Unsuccessful
     * carrier information needed to render this page:
     * contents of Help/Script and Quote Summary, State of the navigation buttons, etc.
     */
    fetchData.getPageData(requestParam).then(async(response) => {
      if(response.data.quote_summary.quote_status === 'Bound') 
       { let allTabs=await this.createPropRc2Tabs(JSON.stringify(response.data.tab_buttons));
        this.pageData = response.data;
        Object.assign(this.pageData.tab_buttons,allTabs);
        }
      else{
      this.pageData = response.data;
      }
      this.pageFieldsArray = this.pageData.fields;
      /* collect blurb data in blurbs array based on position */
      for (let blurb = 0; blurb < this.pageData.blurbs.length; blurb += 1) {
        if (!this.blurbs[this.pageData.blurbs[blurb].location]) {
          this.blurbs[this.pageData.blurbs[blurb].location] = [];
        }
        this.blurbs[this.pageData.blurbs[blurb].location].visible = this.pageData.blurbs[blurb].visible;
        this.blurbs[this.pageData.blurbs[blurb].location].content = this.pageData.blurbs[blurb].content;
      }
      /* blurb data collection ends here */
      /* Page API Call ends here */

      /* call rates API start here */
      const sessionID = this.$store.getters.getSessionID;
      const url = `/carriers/${sessionID}`;

      /**
       * Our Call to retrieve different rates for all carriers
       */
      fetchData.getCarriersData(url).then((response2) => {
       this.lastRC1DateTimeString=response2.data.lastRC1DateTimeString;
        // const carriers = response2.data;
        // this.processCarriersOneCall(carriers);
        this.showProgressBar = true;
        this.processCarriersMultipleCalls(response2);

        /*
        this.$nextTick(() => {
          window.scrollTo(0, 0);
        });
        */
      });
    });
    }
    else 
      {
      this.$store.dispatch('setCurrentNav', response.data.Navigate);
      this.$router.replace(common.getRouteName(response.data.Navigate));
      }
      }).catch((error) => {
        // TODO: Use response (data or http code) to evaluate error
        window.console.warn('An error occurred while requesting a section button post:', error);
        gtag('event', 'exception', {
          description: 'Error requesting section button quote',
          fatal: false, // set to true if the error is fatal
        });
      });   
  },
  mounted() {
    /* eslint no-undef: */
    /* eslint prefer-template:  */
  },
};
</script>

<style scoped lang="scss">
.smaller-text-secondary 
{
  color: $var-text-secondary;
  font-size: 10px;
}
/***Results Header***/
#results-table .selected, #results-table .selected:hover{
  color: #FFFFFF !important;
  background: #003366 !important;
}
.home 
{
 .border-bottom-carriers {
  border-bottom: 10px solid $var-color-home-icon !important;
  } 
  #results-table {
  .selected,.selected:hover{
  color: #FFFFFF !important;
  background: $var-color-home-icon !important;
 }
 .col-head{
  color: $var-color-home-icon;
}
}
}

.condo 
{
 .border-bottom-carriers {
  border-bottom: 10px solid $var-condo-header-icon !important;
  } 
  #results-table {
  .selected,.selected:hover{
  color: #FFFFFF !important;
  background: $var-condo-header-icon !important;
 }
 .col-head{
  color: $var-condo-header-icon;
}
}
}

.renters
{
 .border-bottom-carriers {
  border-bottom: 10px solid $var-renter-section !important;
  } 
 #results-table {
  .selected,.selected:hover{
  color: #FFFFFF !important;
  background: $var-renter-section !important;
 }
 .col-head{
  color: $var-renter-section;
}
}
}
#results-table .selected:hover{
  cursor: default !important;
}


/********************************
#results-table .col-head:hover {
  background: #EEEEEE;
}
********************************/

#results-table .col-head{
   padding: 0.5rem;
   text-align: center;
   color: #003366;
   cursor: default;
   border-radius: 0.25rem 0.25rem 0 0;
 }

/***Progress Bar***/
.progress{
  height: 1.5rem;
}

.bg-greyed {
  background-color: $var-color-grey-knockout;
}


.border-bottom-carriers {
  border-bottom: 10px solid #003366 !important;
}
.btn-primary.refreshButton {
  background-color: #FFFFFF;
  border-color: $var-color-home-icon;
  color: $var-color-home-icon;

  &:hover {
    background-color: $var-color-home-icon;
    border-color: #FFFFFF;
    color: #FFFFFF;
  }
}

/***content top margin breakpoints - adjusts for navigation stacks***/
@media all and (max-width: 1372px) {
  .page-wrap {
    margin-top: 70px;
  }
}
@media all and (min-width: 1371px) {
  .page-wrap {
    margin-top: 35px;
  }
}
.appt-error-msg{
  color: #BB0000;
  font-size: 1.5rem;
  margin-bottom: 40%;
}
.progress-bar-bg {
  background-color: $var-success-green !important;
}
</style>

<style>
  .export-dropdown-col .btn-group.btn-group-toggle {
    width: 80%;
    position: relative;
    right: -56px;
  }
  .quote-panel-open .export-dropdown-col .btn-group.btn-group-toggle {
    right: -46px;
  }
  .export-dropdown-col .dropdown.single {
    width: 100%;
  }
  .export-dropdown-col .dropdown-menu {
    width: 100% !important;
  }
  .vs__selected-options input::placeholder{
    color: #1A1A1A !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/interview/propertyInsurance/CarrierMatches.vue?e24d2a7e